<template>
  <div
    class="sp-page-top min-h-188.5 max-xl:min-h-162.5 max-md:max-h-160"
    :class="[`sp-page-top--${variant}`, ui?.root]"
  >
    <SPHeader :variant="variant">
      <template #hero>
        <SPHero
          v-if="hero"
          :variant="variant"
          :ui="{
            directions: ui.directions,
          }"
          @search="emit('search', $event)"
        >
          <template v-if="$slots['hero-breadcrumbs']" #breadcrumbs>
            <slot name="hero-breadcrumbs" />
          </template>
          <template #title>
            <slot name="hero-title" />
          </template>
          <template #description>
            <slot name="hero-description" />
          </template>
          <template v-if="$slots['hero-search']" #search>
            <slot name="hero-search" />
          </template>
          <template v-if="$slots['hero-directions']" #directions>
            <slot name="hero-directions" />
          </template>
        </SPHero>
      </template>
    </SPHeader>
  </div>
</template>

<script setup lang="ts">
import type { PageVariant } from '~/types'

defineOptions({
  name: 'SPPageTop',
})

withDefaults(
  defineProps<{
    variant?: PageVariant
    hero?: boolean
    ui?: {
      root?: string
      directions?: string
    }
  }>(),
  {
    variant: 'main',
    hero: true,
    ui: () => ({}),
  },
)

const emit = defineEmits<{
  search: [value: string]
}>()

defineSlots<{
  'hero-breadcrumbs': () => any
  'hero-title': () => any
  'hero-description': () => any
  'hero-search': () => any
  'hero-directions': () => any
}>()
</script>

<style lang="scss" scoped>
.sp-page-top {
  padding-bottom: 60px;
  background:
    linear-gradient(
      90.04deg,
      rgba(1, 35, 80, 0.8) 22.14%,
      rgba(1, 35, 80, 0) 53.35%
    ),
    linear-gradient(
      36.7deg,
      rgba(1, 35, 80, 0.24) 31.78%,
      rgba(1, 35, 80, 0) 60.09%
    ),
    url('/images/hero/main-page.webp') no-repeat;
  background-size: cover;

  @include max-md {
    background-position: center;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  &--directions {
    min-height: 500px;
    padding-bottom: 48px;
    background:
      linear-gradient(-4deg, rgba(4, 17, 1, 0) 63%, rgba(4, 17, 1, 0.5) 99%),
      linear-gradient(-90deg, rgba(4, 17, 1, 0) 36%, rgba(4, 17, 1, 0.5) 88%),
      url('/images/hero/directions.webp') center / cover no-repeat;
  }

  &--no-bg {
    background: none;
    min-height: 46px;

    padding-bottom: 18px;
  }
}
</style>
